import { doc, getDoc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { db, auth } from "../firebaseconfig";

// Henter brugerdata fra databasen
export async function getUserData() {
  if (!auth.currentUser) return null;
  const userDocRef = doc(db, "users", auth.currentUser.uid);
  const docSnap = await getDoc(userDocRef);
  return docSnap.exists() ? docSnap.data() : null;
}

// Opdaterer brugerens allergener i databasen
export async function updateUserPreferences(preferences) {
  if (!auth.currentUser) return;
  const userDocRef = doc(db, "users", auth.currentUser.uid);
  await setDoc(userDocRef, { ...preferences }, { merge: true });
}

// Gemmer scannede produkter i databasen
export async function saveScannedItem(productInfo) {
  try {
    if (!auth.currentUser) throw new Error("Brugeren er ikke logget ind.");
    if (!productInfo || Object.values(productInfo).some(value => value === undefined)) {
      throw new Error("Produktdata indeholder ugyldige felter.");
    }

    const userDocRef = doc(db, "users", auth.currentUser.uid);
    await updateDoc(userDocRef, {
      scannedItems: arrayUnion({
        product_name: productInfo.product_name || "Ukendt produkt",
        ingredientsList: productInfo.ingredientsList || "Ingen ingrediensdata",
        categories: productInfo.categories || "Ingen kategorier",
        detectedAllergens: Array.isArray(productInfo.detectedAllergens)
          ? productInfo.detectedAllergens
          : [],
        isSafe: productInfo.isSafe ?? false,
      }),
    });

    console.log("Scanningsresultat gemt:", productInfo);
  } catch (error) {
    console.error("Fejl ved gemning af scanningsresultat:", error.message);
    throw error;
  }
}

// Henter tidligere scannede produkter fra databasen
export async function getScannedItemsFromDatabase() {
  try {
    if (!auth.currentUser) throw new Error("Brugeren er ikke logget ind.");
    const userDocRef = doc(db, "users", auth.currentUser.uid);
    const docSnap = await getDoc(userDocRef);
    return docSnap.exists() ? docSnap.data().scannedItems : [];
  } catch (error) {
    console.error("Fejl ved hentning af scannede varer:", error);
    throw error;
  }
}

